import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function ForYouSection() {
  const points = ['Sos psicóloga, terapeuta ocupacional, fonoaudióloga o psicopedagoga y trabajás con adultos mayores.', 'Llegás a casa después de trabajar y todavía tenés que preparar el material para el día siguiente.', 'Tus pacientes con deterioro leve y moderado necesitan fichas distintas y no tenés tiempo de crear dos versiones de todo.', 'La familia te pregunta si el paciente está mejorando y no tenés un registro claro para mostrarle.', 'Querés diversificar tu consultorio y también atender adolescentes y adultos jóvenes.', 'Buscás algo que funcione desde el primer día sin necesitar capacitación previa.', 'Querés que tu consultorio se vea y funcione como el de una especialista de alto nivel.', 'Sabés que el tiempo que perdés preparando material es tiempo que le robás a tu vida.'];
  return <section className="py-16 sm:py-24 bg-teal-50" data-id="element-108">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-110">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8 text-center" data-id="element-111">
            EL KIT CLÍNICO COGNITIVO™ ES PARA VOS SI…
          </h2>

          <div className="bg-white rounded-lg shadow-lg p-8" data-id="element-112">
            <ul className="space-y-4" data-id="element-113">
              {points.map((point, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.05
            }} className="flex items-start gap-3" data-id="element-114">
                  <Check className="w-6 h-6 text-teal-600 flex-shrink-0 mt-0.5" data-id="element-115" />
                  <span className="text-gray-700 text-lg" data-id="element-116">{point}</span>
                </motion.li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}